import React from 'react';

/**
 * EmailSubmit Component
 * 
 * Renders an email input field and a submit button. 
 * The component allows the user to input an email address and submit it.
 * 
 * @param {Object} props - The component props
 * @param {string} props.email - The current email value
 * @param {Function} props.setEmail - Function to update the email value
 * @param {Function} props.onSubmit - Function to handle the submit action
 * @returns {JSX.Element} - The rendered email input and submit button
 */
const EmailSubmit = ({ email, setEmail, onSubmit }) => {
    return (
        <div style={{ marginTop: '10%' }} className="email-submit">
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <input
                    style={{
                        padding: '2.5%', // Adds padding inside the input field
                        width: '75%', // Sets the input field width to 75% of its container
                        border: 'solid 2px #ddd', // Adds a solid border with a light gray color
                        borderRight: 'none', // Removes the right border to merge with the button
                        borderRadius: '5px 0 0 5px', // Adds rounded corners on the left side
                    }}
                    type="email"
                    placeholder="Enter your email" // Placeholder text in the input field
                    value={email} // Sets the value of the input field
                    onChange={(e) => setEmail(e.target.value)} // Updates email state on change
                />
                <button
                    onClick={onSubmit} // Calls the onSubmit function when clicked
                    style={{
                        padding: '10px 30px', // Adds padding inside the button
                        borderRadius: '0 5px 5px 0', // Adds rounded corners on the right side
                        backgroundImage: 'linear-gradient(45deg, #064D6F 0%, #2b8cb9 51%, #1BB2F8 100%)', // Gradient background color
                        backgroundSize: '200% auto', // Sets the background size for gradient effect
                        border: '0px', // Removes the border
                        color: 'white', // Sets the text color to white
                        fontSize: '16px', // Sets the font size to 16px
                        fontWeight: 700, // Sets the font weight to 700 (bold)
                        textTransform: 'none', // Disables text transformation (e.g., no uppercase)
                        display: 'flex', // Uses flexbox for layout
                        alignItems: 'center', // Vertically centers items within the button
                        justifyContent: 'center', // Horizontally centers items within the button
                        boxShadow: '0px 0px 14px -7px #2b8cb9', // Adds a shadow effect
                        cursor: 'pointer', // Changes the cursor to a pointer on hover
                        userSelect: 'none', // Prevents text selection
                        transition: '0.5s', // Adds a smooth transition effect
                        '&:hover': {
                            backgroundPosition: 'right center', // Adjusts background position on hover
                            color: '#fff', // Changes text color on hover
                            textDecoration: 'none' // Removes text decoration on hover
                        },
                        '&:active': {
                            transform: 'scale(0.95)' // Scales down the button slightly when active
                        }
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default EmailSubmit;
